import {
  GET_PURCHASE,
  GET_PURCHASE_SUCCESS,
  GET_PURCHASE_FAIL,
  DELETE_PURCHASE,
  DELETE_PURCHASE_SUCCESS,
  DELETE_PURCHASE_FAIL,
  UPDATE_PURCHASE,
  UPDATE_PURCHASE_SUCCESS,
  UPDATE_PURCHASE_FAIL,
  ADD_NEW_PURCHASE,
  ADD_PURCHASE_SUCCESS,
  ADD_PURCHASE_FAIL,
  PURCHASE_LOADING,
  PURCHASE_RESET,
} from "./actionType";

export const resetPurchaseState = (actionType) => ({
  type: PURCHASE_RESET,
  payload: { actionType },
});

export const getPurchaseSuccess = (actionType, data) => ({
  type: GET_PURCHASE_SUCCESS,
  payload: { actionType, data },
});

export const getPurchaseFail = (actionType, error) => ({
  type: GET_PURCHASE_FAIL,
  payload: { actionType, error },
});

export const getPurchase = data => ({
  type: GET_PURCHASE,
  payload: data,
});

export const getPurchaseLoading = () => ({
  type: PURCHASE_LOADING
});

export const deletePurchase = data => ({
  type: DELETE_PURCHASE,
  payload: data,
});

export const deletePurchaseSuccess = data => ({
  type: DELETE_PURCHASE_SUCCESS,
  payload: data,
});

export const deletePurchaseFail = error => ({
  type: DELETE_PURCHASE_FAIL,
  payload: error,
});

export const updatePurchase = data => ({
  type: UPDATE_PURCHASE,
  payload: data,
});

export const updatePurchaseFail = error => ({
  type: UPDATE_PURCHASE_FAIL,
  payload: error,
});

export const updatePurchaseSuccess = data => ({
  type: UPDATE_PURCHASE_SUCCESS,
  payload: data,
});

export const addNewPurchase = data => ({
  type: ADD_NEW_PURCHASE,
  payload: data,
});

export const addPurchaseSuccess = data => ({
  type: ADD_PURCHASE_SUCCESS,
  payload: data,
});

export const addPurchaseFail = error => ({
  type: ADD_PURCHASE_FAIL,
  payload: error,
});